import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import {
  Card,
  Flex,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  SimpleGrid,
  Text,
  Button,
  Box,
} from "@chakra-ui/react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { FiChevronLeft, FiChevronRight, FiSearch } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import CustomDataCard from "../../components/CustomDataCard";
import { formatCurrency } from "../../utils/utils";
import { get_all_customer_list } from "../../redux/customerSlice";
import { get_receipt_list, update_payment } from "../../redux/ReceiptNewSlice";
import { get_bank_list } from "../../redux/bankSlice";
import GasCylinderLoader from "../../components/GasCylinderLoader";
import AddReceiptModal from "./AddReceiptModal";

const Receipt = () => {
  const [rows, setRows] = useState(5);
  const [page, setPage] = useState(1);
  const [initialValue, setInitialValue] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useDispatch();
  const [isCustomerLoading, setIsCustomerLoading] = useState(false);

  const {
    isOpen: isAddOpen,
    onOpen: onAddOpen,
    onClose: onAddClose,
  } = useDisclosure();

  const {
    isOpen: isApproveOpen,
    onOpen: onApproveOpen,
    onClose: onApproveClose,
  } = useDisclosure();

  const [selectedReceipt, setSelectedReceipt] = useState(null);
  const toast = useToast();
  const [selectedBank, setSelectedBank] = useState("");
  const [filterReceiptID, setFilterReceiptID] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [filterCustomer, setFilterCustomer] = useState("");
  const [filterOrder, setFilterOrder] = useState("");
  const [filterVoucherDate, setFilterVoucherDate] = useState("");

  const { bank_list, total_bank_count, hasCashInSystem } = useSelector(
    (state) => state.banks
  );

  useEffect(() => {
    dispatch(get_bank_list({ page: 1, rows: 1000 }));
    setInitialValue(1);
  }, [dispatch]);

  const { receipt_list, total_receipt_count, loading } = useSelector(
    (state) => state.receipts
  );
  const { all_customer_list, all_loading } = useSelector(
    (state) => state.customers
  );

  const getModeOfTransactionName = (mode) => {
    switch (String(mode)) {
      case "1":
        return "Phonepay";
      case "2":
        return "GPay";
      case "3":
        return "Paytm";
      case "4":
        return "Cred";
      case "6":
        return "RTGS";
      case "7":
        return "NEFT";
      case "8":
        return "IMPS";
      case "5":
        return "Others";
      default:
        return "N/A";
    }
  };

  useEffect(() => {
    store.dispatch(get_receipt_list({ page: page, limit: rows }));
  }, [page, rows]);

  const handleApproveClick = (receipt) => {
    setSelectedReceipt(receipt);
    onApproveOpen();
  };

  const handleRejectClick = (receipt) => {
    console.log("Rejected:", receipt.id);
  };

  const handleApproveSubmit = async () => {
    if (selectedReceipt.payment_mode.toLowerCase() === "online" && !selectedBank) {
      toast({
        title: "Please select a bank for online payment.",
        status: "warning",
        duration: 2000,
        isClosable: true,
        position: "top-right",
      });
      return;
    }

    const payload = {
      id: selectedReceipt.id,
      userid: selectedReceipt.userid,
      amount: parseFloat(selectedReceipt.amount),
      payment_mode: selectedReceipt.payment_mode.toLowerCase() === "cash" ? "1" : "2",
      orderid: selectedReceipt.orders?.map((order) => order.orderid) || [],
      bank_id: selectedReceipt.payment_mode.toLowerCase() === "online" ? selectedBank : "",
    };

    try {
      await store.dispatch(update_payment(payload)).unwrap();
      toast({
        title: "Receipt approved successfully!",
        status: "success",
        duration: 2000,
        isClosable: true,
        position: "top-right",
      });
      onApproveClose();
      store.dispatch(get_receipt_list({ page, limit: rows }));
    } catch (error) {
      toast({
        title: error || "Approval failed",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top-right",
      });
    }
  };  

  const onPrevious = () => {
    if (page > 1) {
      setPage(page - 1);
      setInitialValue(initialValue - rows);
    }
  };

  const onNext = () => {
    if (rows * page < total_receipt_count) {
      setPage(page + 1);
      setInitialValue(initialValue + rows);
    }
  };

  const getBankNameById = (bank_id) => {
    if (!bank_id) return "N/A";
    const bank = bank_list.find((bank) => bank.value == bank_id);
    return bank ? bank.bankname : "N/A";
  };

  const getPaymentModeName = (payment_mode) => {
    if (!payment_mode) return "N/A";
    const mode = payment_mode.toString().toLowerCase();
    if (mode === "1" || mode === "cash") return "Cash";
    if (mode === "2" || mode === "online") return "Online";
    return payment_mode;
  };

  const formatDate = (dateString) => {
    if (!dateString || dateString === "0000-00-00 00:00:00") return "N/A";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString();
    } catch {
      return "N/A";
    }
  };

  const createReceiptCardData = (receipt) => {
    const isOnline = getPaymentModeName(receipt.payment_mode)?.toLowerCase() === "online";

    const data = [
      { key: "Receipt ID", value: receipt.sr_no || "N/A" },
      {
        key: "Orders Id",
        value: receipt.orders?.map((order) => order.orderid).join(", ") || "N/A",
      },
      { key: "Customer Name", value: receipt.customer_name || "N/A" },
      { key: "Voucher Date", value: formatDate(receipt.voucher_date) },
      { key: "Amount", value: formatCurrency(receipt.amount) },
      { key: "To Received", value: receipt.paid_to || "N/A" },
      { key: "Payment Mode", value: getPaymentModeName(receipt.payment_mode) },
      { key: "Cash Received", value: receipt.cash_received ? `₹${receipt.cash_received}` : "N/A" },
      { key: "Bank", value: getBankNameById(receipt.bank_id) },
      { key: "Narration", value: receipt.narration || "N/A" },
    ];

    if (isOnline) {
      data.splice(
        8,
        0,
        { key: "Transaction Number", value: receipt.transaction_number || "N/A" },
        {
          key: "Mode of Transaction",
          value: getModeOfTransactionName(receipt.mode_of_transaction) || "N/A",
        },
        {
          key: "Online Received",
          value: receipt.online_received ? `₹${receipt.online_received}` : "N/A",
        }
      );
    }

    return data;
  };

  const filteredReceipts = (receipt_list || []).filter((receipt) => {
    const matchesSearch =
      receipt.sr_no?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      receipt.customer_name?.toLowerCase().includes(searchQuery.toLowerCase());

    const matchesReceiptID = filterReceiptID
      ? receipt.sr_no?.toString().toLowerCase().includes(filterReceiptID.toLowerCase())
      : true;

    const matchesStatus = filterStatus ? receipt.status === filterStatus : true;

    const matchesCustomer = filterCustomer
      ? receipt.customer_name?.toLowerCase().includes(filterCustomer.toLowerCase())
      : true;

    const matchesOrder = filterOrder
      ? receipt.orders?.some((order) =>
          order.orderid?.toLowerCase().includes(filterOrder.toLowerCase())
        )
      : true;

    const matchesVoucherDate = filterVoucherDate
      ? receipt.voucher_date === filterVoucherDate
      : true;

    return (
      matchesSearch &&
      matchesReceiptID &&
      matchesStatus &&
      matchesCustomer &&
      matchesOrder &&
      matchesVoucherDate
    );
  });

  return (
    <>
      {/* Top Bar */}
      <Card bg="#fff" paddingInline={5} paddingBlock={2} mb={4} w="100%">
        <Flex
          w="100%"
          direction={["column", "column", "row"]}
          align="center"
          justify="space-between"
          gap={4}
          flexWrap="wrap"
        >
          <Heading fontSize="xl">Receipts</Heading>

          <Flex
            direction={["column", "column", "row"]}
            align="center"
            gap={3}
            flexWrap="wrap"
          >
            <Select
              size="md"
              value={rows}
              onChange={(e) => {
                setRows(Number(e.target.value));
                setPage(1);
                setInitialValue(1);
              }}
              w={["100%", "100%", "auto"]}
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </Select>

            <InputGroup
              bg="#f4f5f7"
              borderRadius={5}
              w={["100%", "100%", "auto"]}
              maxW="sm"
            >
              <Input
                placeholder="Search ....."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <InputRightElement>
                <FiSearch />
              </InputRightElement>
            </InputGroup>

            <Button
              w={["100%", "100%", "auto"]}
              px={6}
              py={2.5}
              fontSize="sm"
              colorScheme="blue"
              onClick={() => {
                setIsCustomerLoading(true);
                store
                  .dispatch(get_all_customer_list())
                  .finally(() => setIsCustomerLoading(false));
                onAddOpen();
              }}
              isLoading={isCustomerLoading || all_loading}
            >
              Add Receipt
            </Button>
          </Flex>
        </Flex>
      </Card>

      {loading ? (
        <GasCylinderLoader size="sm" loadingText="Loading Receipts" />
      ) : (
        <>
          {/* Receipt List */}
          <SimpleGrid minChildWidth="xs" spacing="10px">
            {filteredReceipts?.map((receipt) => (
              <Box key={receipt.id}>
                <CustomDataCard
                  data={createReceiptCardData(receipt)}
                  keyWidth="130px"
                  keyColor="gray.700"
                  valueColor="gray.600"
                  hoverEffect={true}
                />

{receipt.created_by === "1" && receipt.status === "0" && (
                  <Flex justify="center" gap={3} mt={2}>
                    <Button
                      colorScheme="green"
                      size="sm"
                      onClick={() => handleApproveClick(receipt)}
                    >
                      Approve
                    </Button>
                    <Button
                      colorScheme="red"
                      size="sm"
                      onClick={() => handleRejectClick(receipt)}
                    >
                      Reject
                    </Button>
                  </Flex>
                )}
              </Box>
            ))}
          </SimpleGrid>

          {/* Approve Modal */}
          <Modal isOpen={isApproveOpen} onClose={onApproveClose} isCentered size="lg">
            <ModalOverlay />
            <ModalContent borderRadius="xl">
              <ModalHeader>Approve Receipt</ModalHeader>

              <ModalBody>
                {selectedReceipt && (
                  <Card variant="outline" borderRadius="xl" shadow="md" p={4} mb={4}>
                    <SimpleGrid columns={2} spacing={3}>
                      <Box>
                        <Text fontWeight="medium">Receipt ID:</Text>
                        <Text color="gray.600">{selectedReceipt.sr_no || "N/A"}</Text>
                      </Box>

                      <Box>
                        <Text fontWeight="medium">Customer:</Text>
                        <Text color="gray.600">{selectedReceipt.customer_name || "N/A"}</Text>
                      </Box>

                      <Box>
                        <Text fontWeight="medium">Voucher Date:</Text>
                        <Text color="gray.600">
                          {formatDate(selectedReceipt.voucher_date)}
                        </Text>
                      </Box>

                      <Box>
                        <Text fontWeight="medium">Amount:</Text>
                        <Text color="green.600" fontWeight="semibold">
                          ₹{parseFloat(selectedReceipt.amount).toFixed(2)}
                        </Text>
                      </Box>

                      <Box>
                        <Text fontWeight="medium">Payment Mode:</Text>
                        <Text color="gray.600">
                          {getPaymentModeName(selectedReceipt.payment_mode)}
                        </Text>
                      </Box>

                      {selectedReceipt.payment_mode?.toLowerCase() === "cash" && (
                        <Box>
                          <Text fontWeight="medium">Cash Received:</Text>
                          <Text color="gray.600">
                            ₹{parseFloat(selectedReceipt.cash_received || 0).toFixed(2)}
                          </Text>
                        </Box>
                      )}

                      {selectedReceipt.payment_mode?.toLowerCase() === "online" && (
                        <Box>
                          <Text fontWeight="medium">Online Received:</Text>
                          <Text color="gray.600">
                            ₹{parseFloat(selectedReceipt.online_received || 0).toFixed(2)}
                          </Text>
                        </Box>
                      )}

                      <Flex justify="space-between" py={2}>
                        <Text fontWeight="medium">Mode of Transaction:</Text>
                        <Text>
                          {getModeOfTransactionName(selectedReceipt?.mode_of_transaction)}
                        </Text>
                      </Flex>

                      {selectedReceipt.payment_mode?.toLowerCase() === "online" && (
                        <Box>
                          <Text fontWeight="medium">Transaction Number:</Text>
                          <Text color="gray.600">
                            {selectedReceipt.transaction_number || "N/A"}
                          </Text>
                        </Box>
                      )}

                      <Box>
                        <Text fontWeight="medium">Paid To:</Text>
                        <Text color="gray.600">{selectedReceipt.paid_to || "N/A"}</Text>
                      </Box>

                      <Box gridColumn="span 2">
                        <Text fontWeight="medium">Narration:</Text>
                        <Text color="gray.600">{selectedReceipt.narration || "N/A"}</Text>
                      </Box>

                      <Box gridColumn="span 2">
                        <Text fontWeight="medium">Orders:</Text>
                        <Text color="gray.600">
                          {selectedReceipt.orders?.map((order) => order.orderid).join(", ") ||
                            "N/A"}
                        </Text>
                      </Box>
                    </SimpleGrid>
                  </Card>
                )}

                {selectedReceipt &&
                  selectedReceipt.payment_mode?.toLowerCase() === "online" && (
                    <Box mb={4}>
                      <Text mb={1} fontWeight="medium">
                        Select Admin Bank *
                      </Text>
                      <Select
                        placeholder="Select Bank"
                        value={selectedBank}
                        onChange={(e) => setSelectedBank(e.target.value)}
                      >
                        {bank_list.map((bank) => (
                          <option key={bank.id} value={bank.id}>
                            {bank.bankname} - ({bank.bank_branch}) - {bank.accountno}
                          </option>
                        ))}
                      </Select>
                    </Box>
                  )}
              </ModalBody>

              <ModalFooter>
                <Button variant="ghost" onClick={onApproveClose} mr={3}>
                  Cancel
                </Button>
                <Button colorScheme="green" onClick={handleApproveSubmit} isLoading={loading}>
                  Approve
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>

          {/* Add Receipt Modal */}
          <AddReceiptModal
            isOpen={isAddOpen}
            onClose={onAddClose}
            all_customer_list={all_customer_list}
            bank_list={bank_list}
            page={page}
            rows={rows}
          />

          {/* Pagination */}
          <Card
            alignItems={"center"}
            gap={3}
            flexDirection={"row"}
            mt={4}
            justifyContent={"center"}
            padding={3}
          >
            <FiChevronLeft
              cursor={"pointer"}
              color={page === 1 ? "gray" : "#007bc9"}
              size={35}
              onClick={onPrevious}
            />
            <Flex gap={3} alignItems={"center"}>
              <Text>{initialValue}</Text>-
              <Text>{Math.min(rows * page, total_receipt_count)}</Text>
              <Text>of</Text>
              <Text>{total_receipt_count}</Text>
            </Flex>
            <FiChevronRight
              cursor={"pointer"}
              color={rows * page >= total_receipt_count ? "gray" : "#007bc9"}
              size={35}
              onClick={onNext}
            />
          </Card>
        </>
      )}
    </>
  );
};

export default Receipt;